//-------------------------------
// save current editable profile
//-------------------------------
export default function saveCurrentEditableProfile(obj) {
  // -------------
  // define array
  // -------------
  let original_profile = {
    name: obj.name,
    arena: obj.arena,
    arena_name: obj.arena_name,
    player: obj.player,
    player_name: obj.player_name,
    category: obj.category,
    type: obj.type,
    race_name: obj.race_name,
    role: obj.role,
    cults: obj.cults,
    profession: obj.profession,
    gender: obj.gender,
    age: obj.age,
    height: obj.height,
    weight: obj.weight,
    colour_eyes: obj.colour_eyes,
    colour_hair: obj.colour_hair,
    cock: obj.cock,
    distinguishing_marks: obj.distinguishing_marks,
    notes: obj.notes,
    image: obj.image,
    combat_inclusion: obj.combat_inclusion,
  }

  return original_profile
}
